import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

import { PicklistConfig } from '../../../picklist/config/picklist.config';
import { PickListInterface } from '../../../picklist/interfaces/picklist.interface';
import { ESalesOrderPickingStatus } from '../../interfaces/sales-order.interface';
interface IPickingStatusCellRendererParams extends ICellRendererParams {
  pickingStatus :string;
}
@Component({
  selector: 'lum-sales-order-picklist-status-cell-renderer',
  templateUrl: './sales-order-picklist-status-cell-renderer.component.html',
  styleUrls: ['./sales-order-picklist-status-cell-renderer.component.scss'],
})
export class SalesOrderPicklistStatusCellRendererComponent
  implements ICellRendererAngularComp
{
  private cellRendererParams :IPickingStatusCellRendererParams;
  picklistStatus = PicklistConfig.picklistStatus;
  constructor() {}

  agInit(params :IPickingStatusCellRendererParams) :void {
    this.cellRendererParams = params;
  }

  refresh(params :ICellRendererParams<any, any, any>) :boolean {
    // Return true to indicate that the cell content has been updated
    return true;
  }

  get picklist() :PickListInterface {
    return this.cellRendererParams?.data?.picklist;
  }

  get statusDisplay() :string {
    return this.picklistStatus[
      this.cellRendererParams?.pickingStatus
    ]?.toLowerCase();
  }

  get colorClass() :string {
    if (this.statusDisplay) {
      switch (this.cellRendererParams?.pickingStatus) {
        case ESalesOrderPickingStatus.PICKLIST_CREATED:
        case ESalesOrderPickingStatus.PICKLIST_PICKING:
        case ESalesOrderPickingStatus.PICKLIST_PICKED:
          return 'cell-status-circle-yellow';
        case ESalesOrderPickingStatus.NOT_IN_PICKING:
        case ESalesOrderPickingStatus.NO_ENOUGH_STOCKS:
          return 'cell-status-circle-red';
        case ESalesOrderPickingStatus.PICKLIST_PACKED:
          return 'cell-status-circle-green';
        default:
          return '';
      }
    }

    return '';
  }
}
